/* UTF-8 admin tab: policy */
import React from 'react'

export function renderPolicy(ctx) {
  const {
    activeTab,
  } = ctx
  return (
    <>
          {activeTab === 'policy' && (
            <div className="dash-section">
              <div className="dash-section-header">
                <h2>📜 Company Policy</h2>
                <p>Official Groupe Ouambo code of conduct, HR policies, and employee guidelines.</p>
              </div>
              <div className="dash-policy-doc">
                <div className="dash-policy-section">
                  <h3>1. Core Values</h3>
                  <ul>
                    <li>🤝 <strong>Integrity</strong> — Honesty and transparency in all interactions</li>
                    <li>🚀 <strong>Excellence</strong> — Highest standards in every task</li>
                    <li>🌍 <strong>Accountability</strong> — Honoring commitments to clients, colleagues, and communities</li>
                    <li>🤲 <strong>Solidarity</strong> — Supporting one another, valuing diversity</li>
                    <li>🌱 <strong>Sustainability</strong> — Acting with future generations and the environment in mind</li>
                  </ul>
                </div>
                <div className="dash-policy-section">
                  <h3>2. Expected Professional Behaviors</h3>
                  <ul>
                    <li>Treat all colleagues, clients, and partners with respect and dignity</li>
                    <li>Maintain confidentiality of sensitive company and client information</li>
                    <li>Be punctual; notify in advance of any absence or delay</li>
                    <li>Use company resources only for professional purposes</li>
                    <li>No discriminatory, harassing, or intimidating behavior — zero tolerance</li>
                  </ul>
                </div>
                <div className="dash-policy-section">
                  <h3>3. Conflicts of Interest</h3>
                  <ul>
                    <li>All actual or potential conflicts of interest must be disclosed to a supervisor</li>
                    <li>No competing activities without prior written authorization from management</li>
                    <li>Gifts from clients or suppliers must not exceed 25,000 FCFA in value</li>
                    <li>Internal information must never be used for personal or external commercial gain</li>
                  </ul>
                </div>
                <div className="dash-policy-section">
                  <h3>4. Leave and Attendance</h3>
                  <ul>
                    <li><strong>Annual leave:</strong> 18 working days (under 5 yrs tenure) / 24 days (5+ yrs)</li>
                    <li><strong>Sick leave:</strong> up to 15 days/year with medical certificate</li>
                    <li><strong>Maternity leave:</strong> 14 weeks | <strong>Paternity:</strong> 5 days</li>
                    <li>Leave requests: minimum 5 working days advance notice via portal</li>
                    <li>Unapproved absences beyond 3 days trigger disciplinary procedure</li>
                  </ul>
                </div>
                <div className="dash-policy-section">
                  <h3>5. Discipline and Grievances</h3>
                  <p>Breaches of conduct result in: written warning → suspension → termination, depending on severity. Serious offenses (fraud, violence, harassment) trigger immediate termination. Grievances should be addressed first with direct supervisors, then escalated to HR in writing.</p>
                </div>
                <div className="dash-policy-section">
                  <h3>6. Technology and Data</h3>
                  <ul>
                    <li>IT systems reserved for professional use only</li>
                    <li>Passwords must be confidential and rotated every 90 days</li>
                    <li>Any security breach must be reported to IT immediately</li>
                    <li>No unauthorized software installation on company devices</li>
                  </ul>
                </div>
                <div className="dash-policy-meta">
                  <p>Approved by Executive Management — Groupe Ouambo</p>
                  <p>Current version: January 2025 | Next review: January 2026</p>
                </div>
              </div>
            </div>
          )}

          {/* ── SAFETY ──────────────────────────────────────── */}
    </>
  )
}
